import React from 'react';
import ReactModal from 'react-modal';

import ModalInboxOperationContentEdit from '../ModalInboxOperation/ModalInboxOperationContentEdit';

const ModalInboxOperationEdit = ({
  isOpen,
  closeModalEditTransaction,
  transactionToEdit
}) => {

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overflow-modal"
      overlayClassName="modal-overlay">
        <ModalInboxOperationContentEdit
          closeModalEditTransaction={closeModalEditTransaction}
          transactionToEdit = {transactionToEdit}
        />   
    </ReactModal>
  );
};

export default ModalInboxOperationEdit;
